export function humaniseDays(days: number) {
    if (!days) {
        return;
    }
    const monthsEst = Math.floor(days / (365 / 12));
    const yearsEst = Math.floor(days / 365);
    if (yearsEst > 3) {
        return `${yearsEst} year${yearsEst === 1 ? '' : 's'}`;
    }
    if (monthsEst > 0) {
        return `${monthsEst} month${monthsEst === 1 ? '' : 's'}`;
    }
    return `${days} day${days === 1 ? '' : 's'}`;
}
